module.exports = __webpack_public_path__ + "static/media/fms.7cac6b08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fms.png
// module id = 161
// module chunks = 0